module.exports = __webpack_public_path__ + "img/zombieboss1_threaten--joined.c2cd33ac.gif";